// AvatarMenu.tsx
import React from "react";
import { Avatar, Dropdown, Menu, Divider } from "antd";
import {
  UserOutlined,
  LogoutOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import type { MenuProps } from "antd";
import { useHistory } from "react-router-dom";
import localStorageHelpers, {
  StorageKey,
} from "src/common/storage/local-storage-helpers";
import { URL_PATHS } from "src/common/networks/url-paths";
import { post } from "src/common/networks/api-helper";
interface AvatarMenuProps {
  username?: string;
  avatarUrl?: string;
  menuItems?: Array<{
    key: string;
    label: string;
    onClick: () => void;
    icon?: React.ReactNode;
  }>;
  style: object;
}

const AvatarMenu: React.FC<AvatarMenuProps> = ({
  username,
  avatarUrl,
  menuItems = [],
  style,
}) => {
  const history = useHistory();
  const onLogout = () => {
    const data = localStorageHelpers.get(StorageKey.ACCESS_TOKEN);
    console.log(data);
    post(URL_PATHS.LOGOUT, { token: data }, false, true)
      .then((res) => {
        console.log(res);
        if (res && res.data.code === 1000) {
          localStorageHelpers.remove(StorageKey.ACCESS_TOKEN);
          history.push("/login");
        }
      })
      .catch((e) => {
        console.log("ERROR LOGOUT", e);
      });
  };

  const onProfileClick = () => {};
  const onSettingsClick = () => {};
  const menuItemsList: MenuProps["items"] = [
    {
      key: "username",
      label: <strong>{username || "User"}</strong>,
      type: "group",
    },
    { type: "divider" },

    // Các mục mặc định và custom thêm nếu cần
    {
      key: "profile",
      label: "Tài khoản",
      onClick: onProfileClick,
      icon: <UserOutlined />,
    },
    {
      key: "settings",
      label: "Cài đặt",
      onClick: onSettingsClick,
      icon: <SettingOutlined />,
    },
    ...menuItems.map((item) => ({
      key: item.key,
      label: item.label,
      onClick: item.onClick,
      icon: item.icon,
    })),

    { type: "divider" },

    {
      key: "logout",
      label: "Logout",
      onClick: onLogout,
      icon: <LogoutOutlined />,
    },
  ];

  return (
    <Dropdown
      className="menu-slide"
      dropdownRender={() => (
        <div>
          <Menu style={style} items={menuItemsList} />
        </div>
      )}
      trigger={["click"]}
    >
      <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
        <Avatar
          size="large"
          src={avatarUrl}
          icon={!avatarUrl ? <UserOutlined /> : undefined}
        />
      </div>
    </Dropdown>
  );
};

export default AvatarMenu;
